"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedrainbow = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 57",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedrainbow` : '') + (description ? ` desc-brandedrainbow` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedrainbow"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedrainbow"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56 39.54a8.89 8.89 0 0 0-7.15-8.8 13.12 13.12 0 0 0-12.1-8.2c-4.75 0-8.89 2.58-11.19 6.43a9.84 9.84 0 0 0-5.87-1.95 10.1 10.1 0 0 0-9.66 7.43C4.95 33.14 0 36.62 0 41.33c0 4.7 4.84 8.15 9.93 6.9a7.82 7.82 0 0 0 6.7 3.83 7.8 7.8 0 0 0 6.1-2.96A13.96 13.96 0 0 0 35 56.54c5.28 0 10.31-3.3 12.58-8.07a8.85 8.85 0 0 0 8.41-8.93H56Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.84 30.64a13.14 13.14 0 0 0-4.91-5.87C35.17 35.17 23.57 43.8 11.5 50.2a7.83 7.83 0 0 0 5.1 1.84 7.86 7.86 0 0 0 6.1-2.89 14.19 14.19 0 0 0 12.26 7.45H35c5.28 0 10.32-3.54 12.59-8.19 5.4-.2 8.4-4.2 8.39-9.19a8.73 8.73 0 0 0-7.16-8.57h.01Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.6 0A44.22 44.22 0 0 0 7.54 34.2c.82-.04 1.67.04 2.52.25.76-2.6 2.53-4.79 4.92-6.06a38.98 38.98 0 0 1 41-22.77V.34A40.53 40.53 0 0 0 50.59 0Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.6 5.24A38.98 38.98 0 0 0 15 28.39a10.02 10.02 0 0 1 6.4-1.05A33.7 33.7 0 0 1 56 10.92v-5.3c-1.8-.25-3.6-.38-5.4-.38Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.6 10.47a33.7 33.7 0 0 0-29.2 16.87c1.53.26 2.97.85 4.22 1.76 1-1.61 2.33-3 3.92-4.06A28.4 28.4 0 0 1 56 16.24v-5.32c-1.79-.3-3.59-.44-5.4-.45Z",
    fill: "#8AE6EB"
  }));
};
var _default = exports.default = brandedrainbow;